import { Form } from 'antd'
import Button from 'components/Button'
import Drawer from 'components/Drawer'
import Input from 'components/Form/Input'
import Label from 'components/Form/Label'
import Switch from 'components/Form/Switch'
import Select from 'components/Select'
import { FormItem } from 'components/UIComponents/FormStyles'
import {
  CommonFlex,
  FlexWrap,
  FooterFlex,
  GapSpan,
  StartSpan,
  TextDiv,
} from 'modules/Settings/Components/Location/AddLocationDrawer/style'
import React, { useEffect, useState } from 'react'

const AddLocation = ({
  setAddLocationDrawer,
  addLocationDrawer,
  setChangeLocationDrawer,
  getListOfCountries,
  getListOfStates,
  getListOfCities,
  listOfCountries,
  listOfStates,
  listOfCities,
  selectedLocationId,
  setSelectedLocationId,
  handleLocationData,
  singleLocationData,
  getInterViewLocation,
}) => {
  const [locationForm] = Form.useForm()
  const [checkDefault, setCheckDefault] = useState(false)

  const [searchCountry, setSearchCountry] = useState('')
  const [searchState, setSearchState] = useState('')
  const [searchCity, setSearchCity] = useState('')
  const [selectedCountry, setSelectedCountry] = useState({})
  const [selectedState, setSelectedState] = useState({})
  const [selectedCity, setSelectedCity] = useState({})

  useEffect(() => {
    if (selectedLocationId) {
      locationForm.setFieldsValue({
        locationName: singleLocationData?.branchName,
        locationCountry: singleLocationData?.countryId,
        locationState: singleLocationData?.stateId,
        locationCity: singleLocationData?.cityId,
        locationZipcode: singleLocationData?.postalCode,
        locationAddressOne: singleLocationData?.addressLine1,
        locationAddressTwo: singleLocationData?.addressLine2,
      })
      setCheckDefault(singleLocationData?.defaultLocation)
      setSearchCountry(singleLocationData?.country)
      setSearchState(singleLocationData?.state)
      setSearchCity(singleLocationData?.city)

      setSelectedCountry({
        _id: singleLocationData?.countryId,
        name: singleLocationData?.country,
      })
      setSelectedState({
        _id: singleLocationData?.stateId,
        name: singleLocationData?.state,
      })
      setSelectedCity({
        _id: singleLocationData?.cityId,
        name: singleLocationData?.city,
      })
    }
  }, [selectedLocationId])

  useEffect(() => {
    let getData
    getData = setTimeout(() => {
      getListOfCountries({
        searchValue: searchCountry,
      })
    }, 500)
    return () => clearTimeout(getData)
  }, [searchCountry])

  useEffect(() => {
    let getData
    if (Object.keys(selectedCountry).length > 0) {
      if (searchState) {
        getData = setTimeout(() => {
          getStates()
        }, 500)
      } else {
        getStates()
      }
    }
    return () => clearTimeout(getData)
  }, [searchState, selectedCountry])

  const getStates = () => {
    getListOfStates({
      searchValue: searchState,
      countryId: selectedCountry?._id,
    })
  }
  useEffect(() => {
    let getData
    if (Object.keys(selectedState).length > 0) {
      if (searchState) {
        getData = setTimeout(() => {
          getCities()
        }, 500)
      } else {
        getCities()
      }
    }
    return () => clearTimeout(getData)
  }, [searchCity, selectedState])

  const getCities = () => {
    getListOfCities({
      searchValue: searchCity,
      stateId: selectedState?._id,
    })
  }

  const onSubmitFormData = async values => {
    let payload = {
      branchName: values?.locationName,
      addressLine1: values?.locationAddressOne,
      addressLine2: values?.locationAddressTwo,
      city: selectedCity?.name,
      state: selectedState?.name,
      country: selectedCountry?.name,
      cityId: values?.locationCity,
      stateId: values?.locationState,
      countryId: values?.locationCountry,
      postalCode: values?.locationZipcode,
      defaultLocation: checkDefault,
    }

    const status = await handleLocationData(payload)
    if (status) {
      clearAll()
    }
    getInterViewLocation()
    setChangeLocationDrawer(true)
  }

  const clearAll = () => {
    setAddLocationDrawer(false)
    setChangeLocationDrawer(true)
    locationForm.resetFields()
    setCheckDefault(false)
    setSearchCountry('')
    setSearchState('')
    setSearchCity('')
    setSelectedCountry({})
    setSelectedState({})
    setSelectedCity({})
    setSelectedLocationId('')
  }

  const content = () => {
    return (
      <Form
        scrollToFirstError
        id={'locationForm'}
        form={locationForm}
        layout="vertical"
        onFinish={onSubmitFormData}
      >
        <Input
          width="100%"
          label={
            <>
              Branch/Location Name
              <StartSpan>*</StartSpan>
            </>
          }
          placeholder="Enter Location Name"
          name="locationName"
          rules={[
            {
              required: true,
              message: 'Please enter location name.',
            },
          ]}
        />
        <FlexWrap spaceBetween gap="25px">
          <FormItem
            name="locationCountry"
            rules={[{ required: true, message: 'Please select a country.' }]}
            width="50%"
          >
            <Select
              label="Country"
              showSearch
              allowClear
              placeholder="Eg.India"
              OptionData={listOfCountries}
              nameParam="name"
              valueParam="_id"
              onSearch={value => setSearchCountry(value)}
              onChange={(_, { option }) => setSelectedCountry(option)}
              onClear={() => {
                setSearchCountry('')
                setSelectedCountry({})
                if (selectedState?._id) {
                  setSearchState('')
                  setSelectedState({})
                  locationForm.setFieldsValue({ locationState: '' })
                }
                if (selectedCity?._id) {
                  setSearchCity('')
                  setSelectedCity({})
                  locationForm.setFieldsValue({ locationCity: '' })
                }
              }}
              filterOption={false}
            />
          </FormItem>
          <FormItem
            name="locationState"
            rules={[{ required: true, message: 'Please select a state.' }]}
            width="50%"
          >
            <Select
              label="State"
              showSearch
              allowClear
              placeholder="Eg. Karnataka"
              OptionData={listOfStates}
              nameParam="name"
              valueParam="_id"
              onSearch={value => setSearchState(value)}
              onChange={(_, { option }) => setSelectedState(option)}
              onClear={() => {
                setSearchState('')
                setSelectedState({})
                if (selectedCity?._id) {
                  setSearchCity('')
                  setSelectedCity({})
                  locationForm.setFieldsValue({ locationCity: '' })
                }
              }}
              filterOption={false}
              disabled={!selectedCountry?._id}
            />
          </FormItem>
        </FlexWrap>
        <FlexWrap spaceBetween gap="25px">
          <FlexWrap column width="50%">
            <Label>City</Label>
            <FormItem
              name="locationCity"
              rules={[{ required: true, message: 'Please select a city.' }]}
              width="100%"
            >
              <Select
                showSearch
                allowClear
                placeholder=" Eg. Bangalore"
                OptionData={listOfCities}
                nameParam="name"
                valueParam="_id"
                onSearch={value => setSearchCity(value)}
                onChange={(_, { option }) => setSelectedCity(option)}
                onClear={() => {
                  setSearchCity('')
                  setSelectedCity({})
                }}
                filterOption={false}
                disabled={!selectedState?._id}
              />
            </FormItem>
          </FlexWrap>

          <FlexWrap column width="50%">
            <Label>Zipcode</Label>
            <Input
              placeholder=" Eg. 560093"
              width="100%"
              name="locationZipcode"
              type={'number'}
              rules={[
                {
                  validator: (_, value) => {
                    if (value >= 100000 && value <= 999999) {
                      return Promise.resolve()
                    } else {
                      return Promise.reject(
                        new Error('Please Enter Valid Pincode')
                      )
                    }
                  },
                },
              ]}
            />
          </FlexWrap>
        </FlexWrap>
        <GapSpan>
          <Input
            width="100%"
            label={`Address 1`}
            placeholder="Placeholder Text"
            name="locationAddressOne"
            rules={[
              {
                required: true,
                message: 'Please enter address line 1',
              },
            ]}
          />
        </GapSpan>
        <Input
          width="100%"
          label={`Address 2`}
          placeholder="Placeholder Text"
          name="locationAddressTwo"
        />
        <CommonFlex spaceBetween centerVertically>
          <TextDiv>Mark this location as a default location</TextDiv>
          <Switch
            width={'30%'}
            checked={checkDefault}
            onChange={check => setCheckDefault(check)}
          />
        </CommonFlex>
      </Form>
    )
  }
  const footer = () => {
    return (
      <FooterFlex flexEnd>
        <Button.Secondary
          width="88px"
          height="38px"
          text="Cancel"
          onClick={clearAll}
        />
        <Button.Primary
          width="69px"
          height="38px"
          text={selectedLocationId ? 'Update' : 'Add'}
          form={'locationForm'}
          htmlType="submit"
        />
      </FooterFlex>
    )
  }
  return (
    <Drawer
      width="43%"
      title={' Add Location'}
      placement="right"
      visible={addLocationDrawer}
      content={content()}
      footer={footer()}
      onClose={clearAll}
      closable
    />
  )
}

export default AddLocation
